import { combineReducers }  from "redux"

import createReducer from "../../../components/utils/createReducer"

const config = createReducer(
  function () {
    const { ...initialState } = gon
    // console.log("gon.current_user:", gon.current_user)
    return initialState
  }()
)({})

export default () => combineReducers({
  config
})

// Config
export const getBaseUrl = state => state.config.urls.api

// Current User
export const getCurrentUser = state => state.config.current_user
export const isLoggedIn = state => getCurrentUser(state) !== undefined
